import { Templates } from '../../compile';
import { FormOptions } from '../../interfaces/options';

export const DefaultFormOptions: FormOptions = {
	template: Templates.forms_fluid,
	initDefaultCommands: true
};
